import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { usePurchaseFlow } from './purchaseFlowMachine';
import {
  CreateOrderStep,
  ChooseMethodStep,
  ProcessingStep,
  ApprovedStep,
} from '../steps';
import styles from './ModalContainer.module.scss';

const ModalContainer = forwardRef(({ isOpen, onClose }, ref) => {
  const { currentStep, data, orderResponse, goNext, goBack, reset, STEPS } =
    usePurchaseFlow();

  useImperativeHandle(
    ref,
    () => ({
      resetFlow: () => {
        reset();
      },
    }),
    [reset]
  );

  if (!isOpen) return null;

  const handleClose = () => {
    reset();
    onClose();
  };

  const renderStep = () => {
    switch (currentStep) {
      case STEPS.CREATE_ORDER:
        return (
          <CreateOrderStep
            formData={data}
            onNext={goNext}
            onClose={handleClose}
          />
        );

      case STEPS.CHOOSE_METHOD:
        return (
          <ChooseMethodStep
            currentStep={currentStep}
            formData={data}
            orderResponse={orderResponse}
            onNext={goNext}
            onBack={goBack}
            onClose={handleClose}
          />
        );

      case STEPS.PROCESSING:
        return (
          <ProcessingStep
            currentStep={currentStep}
            formData={data}
            orderResponse={orderResponse}
            onNext={goNext}
            onClose={handleClose}
          />
        );

      case STEPS.APPROVED:
        return (
          <ApprovedStep
            currentStep={currentStep}
            formData={data}
            orderResponse={orderResponse}
            onNext={goNext}
            onClose={handleClose}
          />
        );

      default:
        return <div>Estado desconocido</div>;
    }
  };

  return (
    <div className={styles.purchaseModalContainer}>
      <div
        className={styles.modalOverlay}
        onClick={e => {
          // Prevent modal from closing when clicking overlay
          e.stopPropagation();
        }}
      >
        <div
          className={styles.modalContent}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div className={styles.modalBody}>{renderStep()}</div>
        </div>
      </div>
    </div>
  );
});

ModalContainer.displayName = 'ModalContainer';

ModalContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalContainer;
